class AddressBookSource {
    constructor(API) {
        this.API = API;
    }


    async addresses(data) {
        return await this.API.post('/index.php?route=api/customer/address/list', data)
    }
    async add(data) {
        return await this.API.post('/index.php?route=api/customer/address/add', data)
    }

    async edit(data) {
        return await this.API.post('/index.php?route=api/customer/address/edit', data)
    }


    async remove(id) {
        return await this.API.get('/index.php?route=api/customer/address/remove', {
            params: {
                address_id: id
            }
        })
    }


}

export default AddressBookSource
